"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const shared_types_1 = require("@zeals/shared-types");
function renderComponent({ errorCode, unknownErrorPage, }) {
    const { GrpcStatus } = shared_types_1.api.error;
    switch (errorCode) {
        default:
        case GrpcStatus.CANCELLED:
        case GrpcStatus.UNKNOWN:
        case GrpcStatus.INVALID_ARGUMENT:
        case GrpcStatus.DEADLINE_EXCEEDED:
        case GrpcStatus.ALREADY_EXISTS:
        case GrpcStatus.PERMISSION_DENIED:
        case GrpcStatus.RESOURCE_EXHAUSTED:
        case GrpcStatus.FAILED_PRECONDITION:
        case GrpcStatus.ABORTED:
        case GrpcStatus.OUT_OF_RANGE:
        case GrpcStatus.UNIMPLEMENTED:
        case GrpcStatus.INTERNAL:
        case GrpcStatus.UNAVAILABLE:
        case GrpcStatus.DATA_LOSS:
        case GrpcStatus.UNAUTHENTICATED:
            return { unknownErrorPage };
    }
}
const ErrorRenderer = (props) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null, renderComponent(props))));
};
exports.default = ErrorRenderer;
